import { render, staticRenderFns } from "./BlChemParam.vue?vue&type=template&id=06cf91e8"
import script from "./BlChemParam.vue?vue&type=script&lang=js"
export * from "./BlChemParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports